<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <h1 class="text-center">WEB DEVELOPMENT</h1>
      </div>

      <div
        v-for="(website, websiteIndex) in websites"
        :key="websiteIndex"
        class="animation col-xs-12"
      >
        <!-- Carousel container -->
        <div
          :id="`my-pics${websiteIndex}`"
          class="carousel slide"
          data-ride="carousel"
        >
          <!-- Indicators -->
          <ol v-if="website.totalImages > 1" class="carousel-indicators">
            <li
              v-for="(number, imageIndex) in website.totalImages"
              :key="imageIndex"
              :data-target="`#my-pics${websiteIndex}`"
              :data-slide-to="imageIndex"
              :class="{ active: imageIndex == 0 }"
            ></li>
          </ol>

          <!-- Content -->
          <div class="carousel-inner" role="listbox">
            <!-- Slides -->
            <div
              v-for="(number, imageIndex) in website.totalImages"
              :key="imageIndex"
              class="item"
              :class="{ active: imageIndex == 0 }"
            >
              <img
                :src="
                  require(`@/assets/gallery/web-dev/${website.imageFolder}/${number}.${website.imageFormat}`)
                "
                alt=""
              />
            </div>
          </div>

          <!-- Previous/Next controls -->
          <template v-if="website.totalImages > 1">
            <a
              class="left carousel-control"
              :href="`#my-pics${websiteIndex}`"
              role="button"
              data-slide="prev"
            >
              <span class="icon-prev" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a
              class="right carousel-control"
              :href="`#my-pics${websiteIndex}`"
              role="button"
              data-slide="next"
            >
              <span class="icon-next" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </template>
        </div>
        <div class="desc">
          <h2 v-html="website.title"></h2>
          <p v-html="website.desc"></p>
          <a
            v-if="website.visitLink"
            class="btn btn-default download-btn"
            :href="website.visitLink"
            target="_blank"
            role="button"
            >Visit</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //Slide show (bootstrap 3 carousel) link:
  //https://www.quackit.com/bootstrap/bootstrap_3/tutorial/bootstrap_carousel.cfm
  data() {
    return {
      websites: [
        {
          title: "Match Masters",
          desc: `Online matching memory game.<br /><br />`,
          imageFolder: "match-masters",
          totalImages: 5,
          imageFormat: "png",
          visitLink: "https://matchmasters.web.app/",
        },
        {
          title: "DayDay",
          desc: `Daily planner with text editor.<br /><br />`,
          imageFolder: "dayday",
          totalImages: 7,
          imageFormat: "png",
          visitLink: "https://dayday.web.app/",
        },
        {
          title: "Employees list",
          desc: `Web application for keeping records of employees.<br /><br />`,
          imageFolder: "employees-list",
          totalImages: 5,
          imageFormat: "png",
          //visitLink: "https://vraboteni.web.app/",
          visitLink: null,
        },
        {
          title: "Tech Blog",
          desc: `A blog where you can register as a user and publish tech posts.<br /><br />`,
          imageFolder: "tech-blog",
          totalImages: 6,
          imageFormat: "png",
          visitLink: "https://tech-blog-vuecli.web.app/",
        },
        {
          title: "Movie voting",
          desc: `Web application where you can vote for your favourite movies from a collection of certain movies.<br /><br />`,
          imageFolder: "movies-vote",
          totalImages: 3,
          imageFormat: "png",
          visitLink: "https://movies-vote.web.app/",
        },
        {
          title: "Petcare hotel",
          desc: `Petcare hotel homepage.<br /><br />`,
          imageFolder: "petcare",
          totalImages: 13,
          imageFormat: "png",
          visitLink: "https://petcare-homepage.netlify.app/",
        },
        //{
        //  title: "Course searching",
        //  desc: `Search courses by id.<br /><br />`,
        //  imageFolder: "courses",
        //  totalImages: 1,
        //  imageFormat: "webp",
        //  visitLink: null,
        //},
        //{
        //  title: "File upload form",
        //  desc: ``,
        //  imageFolder: "upload-form",
        //  totalImages: 1,
        //  imageFormat: "webp",
        //  visitLink: null,
        //},
        //{
        //  title: "The Front Gate",
        //  desc: `HTML page with sign up form that redirects to a java server page that shows the entered data.<br /><br />`,
        //  imageFolder: "front-gate-mind-palace",
        //  totalImages: 2,
        //  imageFormat: "png",
        //  visitLink: null,
        //},
        {
          title: "<div style='margin-bottom: 20px'>Epic login form</div>",
          //desc: `Made using HTML, CSS, Bootstrap.`,
          imageFolder: "epic-login",
          totalImages: 1,
          imageFormat: "webp",
          visitLink: null,
        },
      ],
    };
  },
};
</script>

<style>
/* Global CSS outside the scoped attribute */
:root {
  --web-primary-color: gold;
  --web-secondary-color: crimson;
}
</style>

<style scoped>
/* Scoped CSS for your component */
.container {
  color: white;
  margin-bottom: 50px;
  padding: 20px;
}

h1 {
  /*text-shadow: 0px 0px 2px crimson;*/
  margin-bottom: 40px;
  color: var(--web-primary-color); /* Using the primary color variable */
}

p {
  margin-top: 5px;
  text-align: justify;
  font-size: 18px;
}

.animation {
  background-color: var(
    --web-secondary-color
  ); /* Using the secondary color variable */
  border: 1px solid var(--web-primary-color); /* Using the primary color variable */
  border-radius: 4px;
  box-shadow: 0px 0px 5px var(--web-primary-color); /* Using the primary color variable */
  padding: 1px;
  margin-bottom: 70px;
}

.desc {
  margin: 5px;
  padding-left: 10px;
  padding-right: 10px;
  border: 2px solid var(--web-primary-color); /* Using the primary color variable */
  border-radius: 4px;
}

.download-btn {
  background-color: rgb(163, 13, 43);
  border: 2px solid white;
  border-radius: 4px;
  box-shadow: 0px 0px 5px white;
  margin-bottom: 10px;
  color: white;
  font-size: 18px;
  padding-left: 15px;
  padding-right: 15px;
}

.download-btn:hover {
  background-color: rgb(163, 13, 43);
  color: white;
  border: 2px solid var(--web-primary-color); /* Using the primary color variable */
}

@media screen and (min-width: 992px) {
  .container {
    padding-left: 200px;
    padding-right: 200px;
  }
}

section {
  /*background-color: #111845;*/
  min-height: 100vh;
}
</style>
